const events = {
  'events-breadcrumbs': 'Events',
  'event-details-title': 'Event',
  'events-filter-title': 'Filter events',
  'event-create-sidebar': 'Create event',
  'events-launch-scenario-field': 'Launch scenarios',
  'events-launch-scenario-field-placeholder': 'Specify launch scenarios',
  'events-form-field-launch-scenario-help': 'You may pass different launch scenarios here in JSON format',
  'events-unpublish-released-admin-warning': 'This event has already been released somewhere in the world. Are you sure you want to unpublish it?',
  'events-unpublish-released-admin-only': 'Only admins can unpublish an event that has already been released somewhere in the world',
  'events-edit-images-update-warning': 'This event has already begun. Updating the images will result in the loss of user progress',
  'events-edit-republish-warning': 'Republishing updates for events that have already been published incurs additional costs',
  'event-types-event': 'Event',
  'event-types-general': 'General',
};

export default events;
